import { init } from '@sentry/browser';
// This is a standalone webpack entry (see apps/web/webpack.config.ts's `additional` list),
// loaded and run independently of vendor.js/app.js, specifically so Sentry's global error
// listeners are still installed if the main app bundle fails to load or throws before hydrating.
// Deliberately no other import from `@phishtool/ui` here — this bundle must stay tiny and
// dependency-free, since importing a component/util risks pulling in React/styled-components
// via the package's barrel exports.
const getPreloadedState = () => {
    try {
        const script = document.getElementById('preloaded-state');
        return (script === null || script === void 0 ? void 0 : script.textContent) ? JSON.parse(script.textContent) : {};
    }
    catch (_a) {
        return {};
    }
};
const { staticData } = getPreloadedState();
const dsn = staticData === null || staticData === void 0 ? void 0 : staticData.env.SENTRY_DSN;
if (dsn) {
    init({
        dsn,
        environment: staticData.env.ENV,
    });
}
